interface Airport {
  inActive: boolean;
  allowed: boolean;
  class: string;
  cultureCode: string;
  fullName: string;
  locationDetails: {
    cityCode: string;
    countryCode: string;
    timeZoneCode: string;
    weightType: string;
    coordinates: {
      latitude: string;
      longitude: string;
    };
    zoneCode: string;
    subZoneCode: string;
  };
  shortName: string;
  stationCode: string;
  currencyCode: string;
}
interface AllowedDestination {
  locationCode: string;
  travelLocationCode: string;
  destinations: string[];
}

export const filterAirports = (
  masterAirportData: Airport[],
  allowedDestinations: AllowedDestination[],
  originStationCode: string
): Airport[] => {
  const allowedDestinationEntry = allowedDestinations
    ?.filter((entry) => entry.locationCode === originStationCode)
    ?.map((entry) => entry.travelLocationCode);
  if (!allowedDestinationEntry) {
    return []; // No allowed destinations found for the given origin.
  }
  return masterAirportData.filter((airport) => allowedDestinationEntry.includes(airport.locationDetails.cityCode));
};

export const filterAirportsWithPopularCities = (airports: Airport[], popularCities: string[],
): Airport[] => {
  return airports.sort((airport, nextAirport) => {
    const indexAirport = popularCities.indexOf(airport.stationCode);
    const indexNextAirport = popularCities.indexOf(nextAirport.stationCode);
    
    if (indexAirport === -1) return 1;
    if (indexNextAirport === -1) return -1; 
    
    return indexAirport - indexNextAirport;
  }); 
};
